// Font Awesome Pro as before (the SVG core replaces <i class="fal fa-…"> with inline SVG), with only
// the icons src/ uses instead of every pack. A new icon needs `npm run icons`; icons.spec.ts fails
// until then.
// @ts-ignore The licensed core has no type declarations.
import '@/assets/fontawesome-pro/fontawesome.min.js'
import { ICON_DEFINITIONS } from '@/assets/fontawesome-pro/icon-definitions'

type FontAwesomeGlobal = { library: { add: (...definitions: typeof ICON_DEFINITIONS) => void } }
;(window as unknown as { FontAwesome: FontAwesomeGlobal }).FontAwesome.library.add(
	...ICON_DEFINITIONS,
)
